import Home from './components/home.vue';
import Features from './components/features.vue';
import Pricing from './components/pricing.vue';
import Support from './components/support.vue';
import Setup from './components/setup.vue';
import GetStarted from './components/getstarted.vue';
import Ui from './components/ui.vue';

export const routes= [
  { path: '/', component: Home },
  { path: '/features', component: Features },
  { path: '/pricing', component: Pricing },
  { path: '/support', component: Support },
  { path: '/support/setup', component: Setup },
  { path: '/support/getstarted', component: GetStarted },
  { path: '/support/ui', component:Ui },
]
